<template>
  <div class="page">
    <v-data-table
      v-if="list"
      :items="list"
      :loading="loading"
      :headers="headers"
      :footer-props="footerProps"
    >
      <template v-slot:item.created="{ item }">
        {{ item.created | formatDate }}
      </template>
      <template v-slot:item.annotationClass="{ item }">
        {{ annotationClass(item.annotation_class).class_name }}
      </template>
      <template v-slot:item.status="{ item }">
        <div
          :class="{
            'green--text': item.status === 'accepted',
            'red--text': item.status === 'rejected'
          }"
        >
          <!-- {{ item.status[0].toUpperCase() + item.status.substring(1) }} -->
          {{ $t("contributions.pathologistTable.annotationStatus." + item.status.toLowerCase()) }}
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { FIND } from "@/store/modules/annotationClass";
import { LIST, LOAD_CONTRIBUTIONS } from "@/store/modules/contributions";

export default {
  data() {
    return {
    };
  },
  computed: {
    ...mapState({ loading: state => state.contributions.loading }),
    ...mapGetters({ list: LIST, annotationClass: FIND }),
    footerProps() {
      return {
        "items-per-page-options": [5, 10, 15],
        "items-per-page-text": this.$t("contributions.pathologistTable.footerText")
      }
    },
    headers() {
      return [
        {
          text: this.$t("contributions.pathologistTable.id"),
          value: "id"
        },
        {
          text: this.$t("contributions.pathologistTable.created"),
          value: "created"
        },
        {
          text: this.$t("contributions.pathologistTable.annotationClass"),
          value: "annotationClass"
        },
        {
          text: this.$t("contributions.pathologistTable.status"),
          value: "status"
        },
        {
          text: this.$t("contributions.pathologistTable.reason"),
          value: "rejected_reason"
        }
      ]
    }
  },
  created() {
    this.$store.dispatch(LOAD_CONTRIBUTIONS);
  }
};
</script>

<style scoped></style>
